import React from 'react'
import PropTypes from 'prop-types'
import { OverlayTrigger, Tooltip, Container } from 'react-bootstrap'

import TypesUtils from '../../inumet_js_lib/utils/typesUtils'
import StrUtils from '../../inumet_js_lib/utils/stringUtils'
import MetConstants from '../../inumet_js_lib/model/datosVars/metConstants'
import { isMobile } from 'react-device-detect'

import './Marker.css'

const MARKER_VECTOR = 'vector'
const MARKER_NORMAL = 'normal'

const BORDER_COLOR_CONV = '#274f73'
const BORDER_COLOR_AUTO = '#274f73'

class DatoVarMapMarker extends React.Component {
    constructor(props) {
        super(props)
        this.onClick = this.onClick.bind(this)
    }

    onClick() {
        if (this.props.onClick) this.props.onClick()
    }

    toRadians(angle) {
        return angle * (Math.PI / 180)
    }

    getPosVector() {
        if (TypesUtils.isNumberOrStrNum(this.props.rotacion)) {
            let dirAngle = Number.parseFloat(this.props.rotacion) + 180
            let angleRads = this.toRadians(
                Number.parseFloat(this.props.rotacion) + 90
            )

            // Inicializa en el centro del circulo

            let x = 13 + Math.cos(angleRads) * 18
            let y = Math.sin(angleRads) * 18

            //      return { transform: "rotateZ(" + dirAngle + "deg)", top, left };

            return {
                transform:
                    'translate(' +
                    x +
                    'px,' +
                    y +
                    'px) rotate(' +
                    dirAngle +
                    'deg) ',
                transformOrigin: '5px 20px',
                top: 0,
                left: 0,
                zIndex: -1,
            }
        }
        return null
    }

    shouldComponentUpdate(nextProps) {
        return (
            this.props.textColor !== nextProps.textColor ||
            this.props.backgroundColor !== nextProps.backgroundColor ||
            (TypesUtils.undefOrNull(this.props.estacion) &&
                TypesUtils.notUndefOrNull(nextProps.estacion)) ||
            (TypesUtils.notUndefOrNull(this.props.estacion) &&
                TypesUtils.undefOrNull(nextProps.estacion)) ||
            this.props.estacion.id !== nextProps.estacion.id ||
            this.props.val1 !== nextProps.val1 ||
            this.props.val2 !== nextProps.val2 ||
            this.props.position !== nextProps.position ||
            this.props.tipo !== nextProps.tipo
        )
    }

    render() {
        let borderColor = BORDER_COLOR_CONV
        let borderWidth = '1px'
        if (this.props.estacion && this.props.estacion.tipoAutomatica) {
            borderColor = BORDER_COLOR_AUTO
            borderWidth = '1px'
        }
        let colStyles = {
            backgroundColor: this.props.backgroundColor,
            color: this.props.textColor,
            borderColor,
            borderWidth,
        }
        if (this.props.estacion.tipoAutomatica) {
            colStyles.borderStyle = 'dashed'
        }
        let flechaDirViento = null
        if (
            this.props.tipo === MARKER_VECTOR &&
            TypesUtils.notUndefOrNull(this.props.rotacion)
        ) {
            let rotationStyle = this.getPosVector()
            if (TypesUtils.notUndefOrNull(rotationStyle))
                flechaDirViento = (
                    <div className="arrow-up" style={rotationStyle}></div>
                )
        }
        let strMarker =
            this.props.val1 + (this.props.val2 ? '/' + this.props.val2 : '')
        let labelEstacion = ''
        let labelDatos = []
        if (
            TypesUtils.notUndefOrNull(this.props.estacion) &&
            TypesUtils.notUndefOrNull(this.props.datosVars)
        ) {
            labelEstacion = this.props.estacion.nombre

            if (this.props.estacion.tipoAutomatica) {
                labelEstacion += ' (Auto)'
            } else {
                labelEstacion += ' (Conv)'
            }
            labelDatos.unshift(
                <p key={this.props.estacion.id}>
                    <strong>{labelEstacion}</strong>
                </p>
            )

            if (TypesUtils.notUndefOrNull(this.props.idsVariablesTooltip)) {
                let datos = this.props.datosVars.getDatosPorIdsVars(
                    this.props.idsVariablesTooltip,
                    this.props.estacion.id,
                    this.props.iFecha
                )

                datos.forEach((dato) => {
                    let txtUnidad = ''
                    if (
                        dato.variable.id ===
                            MetConstants.VAR_ID_INTVIENTO_1H_INST ||
                        dato.variable.id ===
                            MetConstants.VAR_ID_INTRAFAGA_1H_INST ||
                        dato.variable.id ===
                            MetConstants.VAR_ID_INTVIENTO_1H_MAX
                    ) {
                        txtUnidad = '(km/h)'
                    } else {
                        txtUnidad = StrUtils.notNullNotEmpty(
                            dato.variable.unidad
                        )
                            ? '(' + dato.variable.unidad + ')'
                            : ''
                    }
                    let textoNomVar =
                        dato.variable.idStr + ' ' + txtUnidad + ': '
                    if (
                        this.props.opcionesVars &&
                        this.props.opcionesVars[dato.variable.id]
                    ) {
                        textoNomVar =
                            this.props.opcionesVars[dato.variable.id].label +
                            ': '
                    }

                    labelDatos.push(
                        <span key={dato.variable.id}>
                            {textoNomVar + dato.dato}
                            <br></br>
                        </span>
                    )
                })
            }
        }
        let tooltip = isMobile ? (
            <span></span>
        ) : (
            <Tooltip id="tooltip-disabled">{labelDatos}</Tooltip>
        )

        let marker = (
            <OverlayTrigger overlay={tooltip}>
                {/*position={this.props.position}*/}
                <div style={colStyles} className="marker numberCircle shadow">
                    {flechaDirViento}
                    {strMarker}
                </div>
            </OverlayTrigger>
        )

        return (
            <Container>
                <div onClick={this.onClick}>{marker}</div>
            </Container>
        )
    }
}

DatoVarMapMarker.propTypes = {
    estacion: PropTypes.object,
    textColor: PropTypes.string,
    backgroundColor: PropTypes.string,
    idsVariablesTooltip: PropTypes.arrayOf(PropTypes.number),
    val1: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    val2: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    datosVars: PropTypes.object,
    tipo: PropTypes.string,
    rotacion: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    onClick: PropTypes.func,
    position: PropTypes.object,
    iFecha: PropTypes.number,
    opcionesVars: PropTypes.object,
}

export { DatoVarMapMarker as default, MARKER_NORMAL, MARKER_VECTOR }
